import { render, staticRenderFns } from "./AmbulanciasReservarAcciones.vue?vue&type=template&id=aeb64a8e"
import script from "./AmbulanciasReservarAcciones.vue?vue&type=script&lang=js"
export * from "./AmbulanciasReservarAcciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports